module.exports = __webpack_public_path__ + "img/20.92394a1b.png";